<template>
	<section class="Section">
		<div class="Container WhiteBox">
			<div class="BoxWide">
				<div class="Bookmark"><span>Contratti</span></div>
                    <FiltroContratti @FiltraContratti ="filtraContratti($event)" @RimuoviFiltri="this.rimuoviFiltri"></FiltroContratti>   
			</div>                      
        </div>
        <div class = "Container"> 
            <GrigliaContratti :listaContratti="this.listaContratti"></GrigliaContratti>
        </div>      
    </section>      
</template>

<script>
import { apiMixin, contrattiMixin} from "/mixin.js"
import GrigliaContratti from "@/components/GrigliaContratti.vue"
import FiltroContratti from "@/components/FiltroContratti.vue"
import Contratto from '@/models/Contratto.model'

export default {
    name: "Contratti",
    mixins:[apiMixin, contrattiMixin],
    data(){
        return {
            listaContratti:[],
            listaContrattiOriginale:[],
            listaTuttiContratti:[]
        }
    },
    components:{
        GrigliaContratti,
        FiltroContratti
    },
    mounted: function(){
        this.doApiCall("get", "contratti/GetContratti", this.$store.getters.getUtente.Token).then(
            (data) => {
                if(data){
                    var codCli = this.$store.getters.getCompanyUtente    
                    this.listaTuttiContratti = data.map(o => {  
                            return Object.assign(new Contratto(), o)                                                                          
                    });  
                
                    let allContracts =  this.listaTuttiContratti;
                    let filteredContracts =  allContracts.filter(item =>{
                        return item.CodiceCliente == codCli;
                    });
                
                    this.listaContratti = filteredContracts;
                    this.listaContrattiOriginale = filteredContracts;
                }
            }
        );   
    }  
}

</script>
